import React from "react";
import Icon from "./Icon";
export default function Marker(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 9.21667C18.25 14.8167 11.05 19.6167 11.05 19.6167C11.05 19.6167 3.84998 14.8167 3.84998 9.21667C3.84998 7.30711 4.60854 5.47576 5.95881 4.1255C7.30907 2.77524 9.14042 2.01667 11.05 2.01667C12.9595 2.01667 14.7909 2.77524 16.1411 4.1255C17.4914 5.47576 18.25 7.30711 18.25 9.21667Z"
  }));
}
Marker.displayname = "Marker";
//# sourceMappingURL=Marker.js.map